import { CalendarStarFourPointsIcon } from './CalendarStarFourPointsIcon';

/**
 * author: Jeff Anders
 * id AC50F06A-D098-4FE2-87CB-E5B82FB077EF
 * name calendar-star-four-points
 * version: 7.2.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/calendar-star-four-points.svg
 * tags
 * - Date / Time 
 */
export const CalendarAutoIcon = CalendarStarFourPointsIcon;
export default CalendarAutoIcon